import { Component, Input, OnInit, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Benefits } from '@monorepo-channels/channels/domain'
import { MatIconModule } from '@angular/material/icon'
import { trigger, state, style, transition, animate } from '@angular/animations'
import { MatExpansionModule } from '@angular/material/expansion'

@Component({
	selector: 'ui-porto-bank-benefits',
	standalone: true,
	imports: [CommonModule, MatIconModule, MatExpansionModule],
	templateUrl: './benefits.component.html',
	styleUrls: ['./benefits.component.scss'],
	animations: [
		trigger('expandCollapse', [
			state(
				'collapsed',
				style({
					height: '0',
					opacity: '0',
				})
			),
			state(
				'expanded',
				style({
					height: '*',
					opacity: '1',
				})
			),
			transition('collapsed <=> expanded', [animate('200ms ease-out')]),
		]),
	],
})
export class BenefitsUiComponent implements OnInit {
	@Input({ required: true }) benefits: Benefits[] = []

	steps = signal<Array<{ isExpanded: boolean; isAnimating: boolean }>>([])

	ngOnInit(): void {
		this.steps.set(this.benefits.map(() => ({ isExpanded: false, isAnimating: false })))
	}

	get sortedBenefits() {
		return [...this.benefits].sort((a, b) => a.order - b.order)
	}
}
